.picker {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  margin-block: var(--tuna-spacing-2);
}

.label {
  margin: 0;
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-caption-fontSize);
}

.options {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
}

.option {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-default);
  cursor: pointer;
  color: var(--tuna-content-primary);
}

.option:has(input:checked) {
  border-color: var(--tuna-palette-primary-main);
  background: var(--tuna-palette-action-selected);
}

.option input {
  appearance: none;
  position: absolute;
  opacity: 0;
}

.optionText {
  font-size: var(--tuna-typography-body2-fontSize);
}
